import { Component, OnInit } from '@angular/core';
import { ThemeService } from '@app/services/theme/theme.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-light-dark-switch',
  templateUrl: './light-dark-switch.component.html',
  styleUrls: ['./light-dark-switch.component.scss']
})
export class LightDarkSwitchComponent implements OnInit {
  public themeSub: Subscription;
  public theme$: string;
  constructor(
    private _theme: ThemeService
  ) { }

  ngOnInit(): void {
    this._theme.init();
    this._theme.theme$.subscribe(res => this.theme$ = res)
  }

  onSetTheme(theme){
    this._theme.onToggleTheme(theme);
  }

}
